<template>
  <div>
    <v-autocomplete v-model="selectedItem"
                    @change="select($event)"
                    :items="options"
                    :placeholder="$t('products.add-ellipsis')"
                    :menu-props="{ auto: true }"
                    item-text="name"
                    item-value="id"
                    data-test="products-list"
    />

    <ob-list :items="items"
             :no-data-message="$t('products.no-products')"
             @select="open($event)"
             @remove="$emit('remove', $event.id)"
    >
      <template v-slot:icon="{ item }">
        <font-awesome-icon :icon="item.product.category === 'material' ? 'microchip' : 'people-carry'" />
      </template>

      <template v-slot:default="{ item }">
        {{ item.product.name }}
        <span v-if="item.quantity != 1">({{ item.quantity }}x)</span>
      </template>
    </ob-list>

  </div>
</template>

<script>
import ProductOptionsDialog from '../../products/components/product-options-dialog'
import ObList from '../../shared/components/list'

export default {
  name: 'products-in',

  props: [ 'items' ],

  data () {
    return {
      selectedItem: undefined,
    }
  },

  computed: {
    options () {
      return this.$store.state.items['products']
    }
  },

  methods: {
    select (id) {
      const product = this.options.find(x => x.id === id)
      this.$emit('change', { productId: product.id, quantity: 1, price: product.price })

      this.$nextTick(() => this.selectedItem = null)
    },

    async open (product) {
      const result = await this.$dialog.showAndWait(ProductOptionsDialog, { product: product })

      if (result)
        this.$emit('change', result)
    },
  },

  components: {
    ObList
  }
}
</script>

<style scoped lang="scss">

</style>
